export default __webpack_public_path__ + "static/media/elo.201c48ee.png";